import { render, staticRenderFns } from "./ZonasEntregas.vue?vue&type=template&id=4b573162&scoped=true"
import script from "./ZonasEntregas.vue?vue&type=script&lang=js"
export * from "./ZonasEntregas.vue?vue&type=script&lang=js"
import style0 from "./ZonasEntregas.vue?vue&type=style&index=0&id=4b573162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b573162",
  null
  
)

export default component.exports